import { render, staticRenderFns } from "./Widget.vue?vue&type=template&id=da37dd4c&scoped=true&lang=html&"
import script from "./Widget.vue?vue&type=script&lang=js&"
export * from "./Widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da37dd4c",
  null
  
)

export default component.exports